// 检测设备类型
export function isMobile() {
  const userAgent = navigator.userAgent.toLowerCase()
  const mobileRegex = /android|iphone|ipad|ipod|blackberry|iemobile|opera mini/i
  return mobileRegex.test(userAgent)
}

// 检测是否在微信浏览器中
export function isWeChat() {
  const userAgent = navigator.userAgent.toLowerCase()
  return userAgent.includes('micromessenger')
}

// 检测是否在微信小程序中
export function isWeApp() {
  // 微信小程序会注入__wxjs_environment变量
  return typeof window !== 'undefined' && window.__wxjs_environment === 'miniprogram'
}